import "babel-polyfill"
import Vue from "vue"
import Vuetify from "vuetify"
import VueResource from "vue-resource"
import VueRouter from "vue-router"
import VueCookies from "vue-cookies"
import VueCharts from 'vue-chartjs'
import { Bar, Line } from 'vue-chartjs'
import CurrencyField from 'v-currency-field'
import Meta from "vue-meta"
import App from "./App"
import Login from "./Login"
import CreateCompanyForm from "./CreateCompanyForm"
import Dashboard from "./Dashboard"
import AdminExchangeByReceiver from "./AdminExchangeByReceiver"
import AdminWireByReceiver from "./AdminWireByReceiver"
import AdminSubjectsToApprove from "./AdminSubjectsToApprove"
import AdminSubjectsReproved from "./AdminSubjectsReproved"
import AdminSubjectsApproved from "./AdminSubjectsApproved"
import AdminPartnersSubjects from "./AdminPartnersSubjects"
import AdminPartnerCreate from "./AdminPartnerCreate"
import AdminSubjectsSearch from "./AdminSubjectsSearch"
import DynamicDocumentation from "./pages/DynamicDocumentation"
import StaticDocumentation from "./pages/StaticDocumentation"
import ExchangeRequest from "./ExchangeRequest"
import SetPassword from "./SetPassword"
import AllowSubjectDataSharing from "./AllowSubjectDataSharing"
import ResetPassword from "./ResetPassword"
import AdminWire from "./AdminWire"
import AdminExchangeList from "./AdminExchangeList"
import AdminWireList from "./AdminWireList"
import AdminBankTransactionList from "./AdminBankTransactionList"
import AdminSmartbankStatement from "./AdminSmartbankStatement"
import AdminUnmatchedScheduledBankTransactionList from "./AdminUnmatchedScheduledBankTransactionList"
import AdminSubjectsFinancialAccountAuthorizationList from "./AdminSubjectsFinancialAccountAuthorizationList"
import CustomerScheduledBankTransactionList from "./CustomerScheduledBankTransactionList"
import CustomerScheduledNewBankTransaction from "./CustomerScheduledNewBankTransaction"
import CustomerWireList from "./CustomerWireList"
import CustomerWireListNew from "./CustomerWireListNew"
import CustomersListPending from "./CustomersListPending"
import CustomersListApproved from "./CustomersListApproved"
import CustomersListReproved from "./CustomersListReproved"
import PixPaymentPage from "./pages/PixPaymentPage"
import CustomersSubjectsSearch from "./CustomersSubjectsSearch"
import CustomersSubjectsNew from "./CustomersSubjectsNew"
import BankAccountsPage from "./pages/BankAccountsPage"
import ConfigPage from "./pages/ConfigPage";
import PixWiresPage from "./pages/PixWiresPage";
import UsersPage from "./pages/UsersPage"
import TwoFactorAuthenticationSetup from "./TwoFactorAuthenticationSetup"
import TwoFactorAuthenticationLogin from "./TwoFactorAuthenticationLogin"
import AccountShareCode from "./AccountShareCode"
import ClientExchange from './ClientExchange';
import ClientExchangeList from './ClientExchangeList';
import ReceiptPage from './pages/ReceiptPage'
import ConfirmThreeDSTransaction from './ConfirmThreeDSTransaction'
import "./directives/Closable.js"
import "./directives/Visible.js"
import exchangeStore from "./stores/Exchanges"
import companyStore from "./stores/Companies"
import socketStore from "./stores/Sockets"
import { currencies, crypto_currencies, local_currencies, isLocalCurrency, isCryptoCurrency} from "./shared/Currencies"
import i18n from "./shared/Translations"

import "vuetify/dist/vuetify.min.css";
import "v-currency-field/dist/index.css";
import "../static/currency-flags.min.css";
import utils from "./shared/Utils"
import InfractionsPage from "./pages/InfractionsPage.vue"
import ChargebackPage from "./pages/ChargebackPage.vue"

// Phoenix Channel Client
// deps/phoenix/assets/js/phoenix.js

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(Vuetify)
Vue.use(Meta)
Vue.use(CurrencyField)

const routes = [
  { path: "/register/company", component: CreateCompanyForm },
  { path: "/sign_in", component: Login },
  { path: "/reset_password", component: ResetPassword },
  { path: "/reset_password/:user_id/:confirmation_code", component: SetPassword },
  { path: "/share_account_info/:id", component: AllowSubjectDataSharing },
  { path: "/exchange/request", component: ExchangeRequest },
  { path: "/bank_accounts", component: BankAccountsPage },
  { path: "/account_share_code", component: AccountShareCode },
  { path: "/dashboard", component: Dashboard },
  { path: "/transactions/new", component: CustomerScheduledNewBankTransaction },
  { path: "/transactions", component: CustomerScheduledBankTransactionList },
  { path: "/users", component: UsersPage },
  { path: "/wires", component: CustomerWireListNew },
  { path: "/customers", component: CustomersListPending },
  { path: "/customers/new", component: CustomersSubjectsNew },
  { path: "/customers/search", component: CustomersSubjectsSearch },
  { path: "/customers/approved", component: CustomersListApproved },
  { path: "/customers/reproved", component: CustomersListReproved },
  { path: "/payment/pix_global", component: PixPaymentPage },
  { path: "/admin/subjects/search", component: AdminSubjectsSearch },
  { path: "/admin/subjects/to_approve", component: AdminSubjectsToApprove },
  { path: "/admin/subjects/reproved", component: AdminSubjectsReproved },
  { path: "/admin/subjects", component: AdminSubjectsApproved },
  { path: "/admin/partners", component: AdminPartnersSubjects },
  { path: "/admin/partner/create", component: AdminPartnerCreate },
  { path: "/admin/exchange", component: AdminExchangeByReceiver },
  { path: "/admin/exchange/list", component: AdminExchangeList },
  { path: "/admin/bank_transaction/list", component: AdminBankTransactionList },
  { path: "/admin/smartbank/statement", component: AdminSmartbankStatement },
  { path: "/admin/config", component: ConfigPage },
  { path: "/admin/scheduled_bank_transaction/unmatched", component: AdminUnmatchedScheduledBankTransactionList },
  { path: "/admin/wire", component: AdminWireByReceiver },
  { path: "/admin/wire/list", component: AdminWireList },
  { path: "/admin/pix_wires", component: PixWiresPage },
  { path: "/admin/subjects/financial_account_authorization", component: AdminSubjectsFinancialAccountAuthorizationList },
  { path: "/admin/infractions", component: InfractionsPage },
  { path: "/admin/chargebacks", component: ChargebackPage },
  { path: "/docs/", beforeEnter() { window.location.href = "https://docs.facilitapay.com"; } },
  { path: "/docs/section/:section_path", beforeEnter() { window.location.href = "https://docs.facilitapay.com"; } },
  { path: "/documentation", beforeEnter() { window.location.href = "https://docs.facilitapay.com"; } },
  { path: "/exchange", component: ClientExchange},
  { path: "/exchange/list", component: ClientExchangeList },
  { path: "/receipt/:id", component: ReceiptPage },
  { path: "/confirm_threeds_transaction", component: ConfirmThreeDSTransaction },
  { path: "/", component: App }
]

const router = new VueRouter({
  routes
})
const app = new Vue({
  router
})

const base_url = 'https://api.facilitapay.com'

app.urls = {
  admin__user__bank_accounts: `${base_url}/api/v1/admin/user/bank_accounts/`,
  admin__user_company_setup: `${base_url}/api/v1/admin/users/company_setup`,
  admin__users__token: `${base_url}/api/v1/admin/users/token`,
  admin__bank_transactions__for_exchange_by_receiver: `${base_url}/api/v1/admin/bank_transactions/for_exchange_by_receiver/`,
  admin_exchanges: `${base_url}/api/v1/admin/exchanges/`,
  admin_exchanges_pending_count: `${base_url}/api/v1/admin/exchanges/pending`,
  admin_bank_transactions: `${base_url}/api/v1/admin/bank_transactions/`,
  admin_companies_for_clearance: `${base_url}/api/v1/admin/companies/for_clearance/`,
  admin_companies_cleared: `${base_url}/api/v1/admin/companies/cleared/`,
  admin_companies_reproved: `${base_url}/api/v1/admin/companies/reproved/`,
  admin_companies: `${base_url}/api/v1/admin/companies/`,
  admin__auto_schedule_bank_accounts: `${base_url}/api/v1/admin/auto_schedule_bank_accounts`,
  admin__update_partner_company_config: `${base_url}/api/v1/admin/companies/ID/config`,
  admin__company_bank_account_statement: `${base_url}/api/v1/admin/bank_accounts/ID/statement`,
  admin__payout_bank_accounts: `${base_url}/api/v1/admin/bank_accounts/payouts`,
  admin__bank_accounts: `${base_url}/api/v1/admin/companies/ID/bank_accounts`,
  admin__company_taxes: `${base_url}/api/v1/admin/companies/ID/taxes/`,
  admin__company_users: `${base_url}/api/v1/admin/companies/ID/users/`,
  admin__company_partners: `${base_url}/api/v1/admin/companies/partners/`,
  admin__company_user__id: `${base_url}/api/v1/admin/companies/ID/users/`,
  admin__user_favorites: `${base_url}/api/v1/admin/user/favorites/`,
  admin__search_cpf: `${base_url}/api/v1/admin/company_cpf_search/`,
  admin__search_cnpj: `${base_url}/api/v1/admin/company_cnpj_search/`,
  admin__search_curp: `${base_url}/api/v1/admin/company_curp_search/`,
  admin__search_cc: `${base_url}/api/v1/admin/company_cc_search/`,
  admin__search_nit: `${base_url}/api/v1/admin/company_nit_search/`,
  admin__search_rut: `${base_url}/api/v1/admin/company_rut_search/`,
  admin__search_passport: `${base_url}/api/v1/admin/company_passport_search/`,
  admin__search_tax_id: `${base_url}/api/v1/admin/company_tax_id_search/`,
  admin__search: `${base_url}/api/v1/admin/company_search`,
  subject_companies: `${base_url}/api/v1/subject/companies/`,
  bank_accounts: `${base_url}/api/v1/bank_accounts/`,
  customer__bank_accounts_balance: `${base_url}/api/v1/bank_accounts/ID/balance`,
  companies: `${base_url}/api/v1/companies/`,
  users: `${base_url}/api/v1/users/`,
  admin__users: `${base_url}/api/v1/admin/users/`,
  admin__bank_accounts_new: `${base_url}/api/v1/admin/bank_accounts/`,
  admin__bank_accounts_one: `${base_url}/api/v1/admin/bank_accounts/ID`,
  admin__bank_accounts_owners: `${base_url}/api/v1/admin/bank_account_owners/`,
  admin__bank_accounts_transactions_count: `${base_url}/api/v1/admin/bank_accounts/transactions/count`,
  admin__bank_accounts_wires_count: `${base_url}/api/v1/admin/bank_accounts/wires/count`,
  admin__bank_accounts_balance: `${base_url}/api/v1/admin/bank_accounts/ID/balance`,
  me: `${base_url}/api/v1/me/`,
  exchange_rates: `${base_url}/api/v1/exchange_rates/`,
  account_share_code: `${base_url}/api/v1/account_share_code/`,
  upload: `${base_url}/api/v1/upload/`,
  public_uploads: `${base_url}/api/v1/files/`,
  customer__bank_transactions_refund: `${base_url}/api/v1//admin/bank_transactions/ID/refund`,
  customer__scheduled_bank_transactions: `${base_url}/api/v1/transactions/`,
  customer__scheduled_bank_transactions_id: `${base_url}/api/v1/transactions/ID`,
  customer__scheduled_transaction_statement: `${base_url}/api/v1/bank_accounts/ID/statement`,
  customer__subject: `${base_url}/api/v1/subject/`,
  customer__subject__bank_accounts: `${base_url}/api/v1/subject/ID/bank_accounts`,
  customer__subject__transaction_values: `${base_url}/api/v1/subject/ID/transaction_values`,
  customer__search: `${base_url}/api/v1/subject/search/`,
  customer__people: `${base_url}/api/v1/subject/people/`,
  customer__people__id: `${base_url}/api/v1/subject/people/ID`,
  customer__companies: `${base_url}/api/v1/subject/companies/`,
  customer__companies__id: `${base_url}/api/v1/subject/companies/ID`,
  customer__company_wires: `${base_url}/api/v1/wires`,
  customer__receipt: `${base_url}/api/v1/receipt/`,
  customer__show_partner_company_config: `${base_url}/api/v1/companies/ID/config`,
  fx_bank_accounts: `${base_url}/api/v1/facilitapay/bank_accounts`,
  admin__fx_bank_accounts_by_partner_id: `${base_url}/api/v1/admin/facilitapay/bank_accounts/ID`,
  admin__fx_bank_accounts_facilita_wire_bank_account: `${base_url}/api/v1/admin/facilitapay/bank_accounts/facilita_wire_bank_account/FACILITA_WIRE_ACCOUNT_INTEGRATION_NAME/balance`,
  admin__bank_transactions__for_exchange: `${base_url}/api/v1/admin/bank_transactions/for_exchange/`,
  admin__bank_transactions__for_wire: `${base_url}/api/v1/admin/bank_transactions/for_wire/`,
  admin__load_bank_transactions: `${base_url}/api/v1/admin/load_bank_transactions`,
  admin__load_exchange_bank_transactions: `${base_url}/api/v1/admin/load_exchange_bank_transactions`,
  admin__load_exchanges: `${base_url}/api/v1/admin/load_exchanges`,
  admin__load_companies: `${base_url}/api/v1/admin/companies/load`,
  admin__company_wires: `${base_url}/api/v1/admin/company_wires`,
  admin__load_company_wire_bank_transactions: `${base_url}/api/v1/admin/load_company_wire_bank_transactions`,
  admin__unmatched_scheduled_bank_transactions: `${base_url}/api/v1/admin/scheduled_bank_transactions/unmatched`,
  admin__scheduled_bank_transactions: `${base_url}/api/v1/admin/scheduled_bank_transactions/`,
  admin__smartbank_statement: `${base_url}/api/v1/admin/smartbank/statement/`,
  admin__smartbank_credit_details: `${base_url}/api/v1/admin/smartbank/credit_details/`,
  admin__smartbank_debit_details: `${base_url}/api/v1/admin/smartbank/debit_details/`,
  admin__smartbank_pix_details: `${base_url}/api/v1/admin/smartbank/pix_details/`,
  admin__smartbank_balance: `${base_url}/api/v1/admin/smartbank/balance/`,
  admin_subjects_financial_account_authorization_base: `${base_url}/api/v1/admin`,
  admin_subjects_financial_account_authorization: `${base_url}/api/v1/admin/account_requests`,
  admin__list_infractions: `${base_url}/api/v1/admin/infractions`,
  admin__cancel_infraction: `${base_url}/api/v1/admin/infractions/ID/cancel`,
  admin__analyze_infraction: `${base_url}/api/v1/admin/infractions/ID/analyze`,
  admin__request_chargeback: `${base_url}/api/v1/admin/chargebacks`,
  admin__list_chargebacks: `${base_url}/api/v1/admin/chargebacks`,
  admin__cancel_chargeback: `${base_url}/api/v1/admin/chargebacks/ID/cancel`,
  admin__analyze_chargeback: `${base_url}/api/v1/admin/chargebacks/ID/analyze`,
  admin__create_infraction: `${base_url}/api/v1/admin/infractions/`,
  admin__create_chargeback:`${base_url}/api/v1/admin/chargebacks/`,
  sign_in: `${base_url}/api/v1/sign_in`,
  sign_up: `${base_url}/api/v1/sign_up`,
  admin__config: `${base_url}/api/v1/admin/config`,
  admin__holidays: `${base_url}/api/v1/admin/holidays`,
  reset_password: `${base_url}/api/v1/reset_password`,
  allow_subject_data_sharing: `${base_url}/api/v1/allow_subject_data_sharing`,
  request_password_reset: `${base_url}/api/v1/request_password_reset`,
  cep_api: 'https://api.postmon.com.br/v1/cep/',
  twofactorauthentication_secret: `${base_url}/api/v1/2fa/secret`,
  twofactorauthentication_code: `${base_url}/api/v1/2fa/code`,
  customer__transactions_for_exchange: `${base_url}/api/v1/transactions/for_exchange`,
  customer__load_bank_transactions: `${base_url}/api/v1/load_bank_transactions`,
  customer__company_taxes: `${base_url}/api/v1/taxes`,
  customer__exchanges: `${base_url}/api/v1/exchanges`,
  customer__exchanges_calculate: `${base_url}/api/v1/exchanges/calculate`,
  admin__onboard: `${base_url}/api/v1/admin/onboard`,
  openpay_confirm_threeds_transaction: `${base_url}/api/v1/transactions/confirm`,
  admin__bank_transactions_cancel: `${base_url}/api/v1/admin/transaction/ID/cancel`
}

app.getEnvironment = () => {
  switch(base_url) {
    case 'https://api.facilitapay.com':
    case 'https://api.facilitafx.com':
      return 'prod'
    case 'https://sandbox-api.facilitapay.com':
      return 'sandbox'
    default:
      return 'dev'
  }
}

app.getBaseUrl = () => {
  return base_url
}

app.getUserPermissions = () => {
  return (app.$cookies.isKey("user_permissions") && JSON.parse(app.$cookies.get("user_permissions"))) || []
}

app.userAllowedTo = (permission) => {
  return app.getUserPermissions().includes(permission)
}

app.authenticationStore = {}
app.authenticationStore.redirectIfNotAuthenticated = () => {
  let signed_in = app.$cookies.isKey('api_token') && app.$cookies.get('api_token') !== ''
  if (!signed_in) {
    app.$router.push('/')
    return
  }
  const is_2fa_authenticated = app.$cookies.get('2fa_authenticated')

  if( is_2fa_authenticated !== "true" ) {
    app.$router.push('/sign_in')
    return
  }
}

let bank_transaction_last_bank_account_id = app.$cookies.isKey('bank_transaction_last_bank_account_id') && app.$cookies.get('bank_transaction_last_bank_account_id') || null

app.store = { bank_transaction_last_bank_account_id }
app.$on('bank_transaction_last_bank_account_id', (id) => {
  let expire_at = new Date((new Date).getTime() + 60*12*60000) // 12 hours
  app.$cookies.set('bank_transaction_last_bank_account_id', id, expire_at)
  app.store.bank_transaction_last_bank_account_id = id
})

exchangeStore.init(app)
companyStore.init(app)
socketStore.init(app)

app.i18n = i18n
app.currencies = currencies
app.crypto_currencies = crypto_currencies
app.local_currencies = local_currencies
app.isLocalCurrency = isLocalCurrency
app.isCryptoCurrency = isCryptoCurrency

// using the user's cookies, if any, or the browser's default language instead
function defineGlobalLanguage() {
  if ( app.$cookies.isKey('lang') && app.$cookies.get('lang') !== '') {
    return app.$cookies.get('lang')
  }
  if (utils.browserLanguage() === 'pt') {
    return 'pt'
  }
  return 'en'
}
app.lang = defineGlobalLanguage()

app.l = (str) => {
  app.lang = defineGlobalLanguage()
  return app.i18n[str] && app.i18n[str][app.lang] || str
}

app.localeCurrency = (value, currency) => {
  let locale = defineGlobalLanguage() === 'en' ? 'en-US' : 'pt-BR'
  return utils.localeCurrency(value, currency, locale)
}

const skip_2fa_setup = {
  'dev': ['gustavo.paludetto@facilitapay.com', 'paludetto@gmail.com', 'potew0@gmail.com', 'andre.palhares@facilitapay.com'],
  'sandbox': ['paludetto@gmail.com','gustavo.paludetto@facilitapay.com', 'potew0@gmail.com', 'andre.palhares@facilitapay.com', 'openpay@facilitapay.com', 'qafpay@uorak.com', 'qualityassurance@uorak.com'],
  'prod': ['']
}

app.skip_2fa_for = function(email) {
  const env = app.getEnvironment()
  return skip_2fa_setup[env].includes(email)
}

app.localStorageStore = {
  save: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  load: (key) => {
      var value = localStorage.getItem(key);
      if (value) {
        return JSON.parse(value);
    }
    return null;
  },
  remove: (key) => {
    localStorage.removeItem(key);
  }
}

app.$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js